<template>
  <sweet-modal width="600px" title="Assign Tax" blocking ref="modal" class="modal" v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-position="left" label-width="120px">
      <el-form-item size="mini" prop="accountId" :label="$t('modal_account')">
        <el-select v-model="form.accountId" :placeholder="$t('modal_account')" style="width: 300px;">
          <el-option
              v-for="type in accounts"
              :key="type.id"
              :label="type.name"
              :value="type.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button @click="create('form')" type="primary">{{$t('general_assign')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "AssignTaxAccountModal",
  components: {
    SweetModal
  },
  props: {
    accounts: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      form: {
        accountId: null,
      },
      rules: {
        accountId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ]
      },
      params: {}
    }
  },
  methods: {
    openModal(params){
      console.log(params)
      this.params = params
      this.$refs.modal.open()
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/account/assignAccountToTaxAccount?accountId=${this.params.data.id}&assignToTaxAccountId=${this.form.accountId}`).then(response => {
            console.log(response)
            this.notification(this.$t('modal_settings_success'), this.$t('modal_settings_taxSuccessfullyAssigned'), "success")
            this.$refs.modal.close()
            loader.hide()
            this.$emit('loadList', { entityType: 'account', id: this.params.data.id })
          }).catch(err => {
            console.log(err)
            loader.hide()
          })
        }
      })
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    close() {
      this.form.accountId = null
      this.params = {}
      this.$refs['form'].resetFields()
    }
  }
}
</script>

<style scoped>

</style>
